module.exports = __webpack_public_path__ + "img/SPXUSD.0c362bb8.png";